import $ from 'jquery';
import {Cart, CheckoutForm} from "racebox-store-package";

document.addEventListener('DOMContentLoaded', function() {
    let form = $('#checkout-form')
    // an empty cart, or a proforma that is paid, cancelled or expired, renders without the form
    if (!form.length) {
        return;
    }
    let ajaxURL = form.attr('action')
    window.cart = new Cart($('main .cart').first());
    window.checkoutForm = new CheckoutForm(form, window.cart, ajaxURL);
});
